import "./EventPromoBlock.scss";
import {
  BlockTop,
  EventPromoItem,
  GridPresetOneHalf,
  GridPresetWideContent,
  GridRow,
  OptimizelyEditProperty,
} from "/App.Components";
import { EventPromoBlockProps } from "/Models/Generated/EventPromoBlockProps";
import { RowSpacing } from "/Components/Layout/GridRow/GridRow";

const EventPromoBlock = ({
  blockTop,
  items,
  itemsPropertyName,
}: EventPromoBlockProps) => {
  return (
    <div className={"event-promo-block-norad"}>
      {blockTop && (
        <GridRow>
          <GridPresetWideContent>
            <BlockTop {...blockTop} />
          </GridPresetWideContent>
        </GridRow>
      )}
      <OptimizelyEditProperty propertyName={itemsPropertyName} clientRender>
        <GridRow rowSpacing={RowSpacing.eventItemCards}>
          {(items?.length ?? 0) > 0 &&
            items?.map((item, idx) => (
              <GridPresetOneHalf key={idx}>
                <EventPromoItem {...item} isTopItem={idx === 0} />
              </GridPresetOneHalf>
            ))}
        </GridRow>
      </OptimizelyEditProperty>
    </div>
  );
};

export default EventPromoBlock;
